import { React } from 'Imports';

const styles = require('./Loader.scss') as {
    loader: string;
    container: string;
    dot: string;
    dotEmpty: string;
    main: string;
    mobileLoader: string;
};

interface ILoaderProps {
    isMobileView?: boolean;
    size?: number;
    color?: string;
}

const Loader = ({ isMobileView, size, color }: ILoaderProps): JSX.Element => {
    const style = {
        ...(size !== undefined && { '--loader-size': `${size}px` }),
        ...(color !== undefined && { '--loader-dot-color': color }),
    } as React.CSSProperties;

    return (
        <div className={isMobileView ? styles.mobileLoader : styles.loader} style={style}>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
            <div className={styles.container}>
                <div className={styles.dot}></div>
            </div>
        </div>
    );
};

export default Loader;
